import React, { Component } from 'react';
import InputText from '../common/InputText';
import SelectCitySayt from '../common/SelectCitySayt';
import ReactTooltip from "react-tooltip";
import InputPhone from '../common/InputPhone';
import InputPhoneEstero from '../common/InputPhoneEstero';
import InputMail from "../common/InputMail";
import SelectCountry from "../common/SelectCountry";

export default class DetailsPecSpidmail extends Component {

    constructor(props) {
        super(props);

        // Indica se il dato è in modifica o creazione
        var dataModify = false;

        const oldChecked = window.oldFormData?.dettaglioNazione === 'on';

        this.state = {
            dataModify: dataModify,
            detailsPec_nazioneEstera: ((this.props.detailsPec.nazioneEstera && this.props.detailsPec.nazioneEstera == 'on') || (this.props.detailsPec.country != 'IT' && this.props.detailsPec.country != undefined  && this.props.detailsPec.country != '' & this.props.detailsPec.country != null)) || false, // Stato per il checkbox di nazione estera
            dettaglioNazione: oldChecked,
        };

    }

    handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
        this.props.handleChange(event);
        // azzero il campo city perchè originato da select se utente residente in italia
        this.props.detailsPec.city = '';
        this.props.detailsPec.country = '';
        //azzero il numero di telefono mobile per evitare errori di validazione con libphoeonenumber-js (che verifica sempre il +39)
        this.props.detailsPec.mobileNumber = '';
        //azzero lo zip code
        this.props.detailsPec.zip = '';
    }

    render() {
        const niceDate = (new Intl.DateTimeFormat("it-IT", {
            year: "numeric",
            month: "long",
            day: "2-digit"
        })).format(this.props.detailsPec.birthDate)

        return (
            <React.Fragment>
                Stai attivando SpidMail a nome di <a href="#="
                    data-place="bottom"
                    data-class="border-dark"
                    data-type="light"
                    data-multiline="true"
                    data-html={true}
                    data-for="anagrafica"
                    data-tip={"Luogo e data di nascita</br><b>" + this.props.detailsPec.birthCity + " " + niceDate + "</b>"}
                >{this.props.detailsPec.name} {this.props.detailsPec.surname} ({this.props.detailsPec.taxCode})</a>
                <ReactTooltip id="anagrafica" /><br />
                {this.props.detailsPec.email && false &&
                    <>
                        <b>{this.props.detailsPec.email}</b> è l'indirizzo email su cui ti invieremo le comunicazioni importanti per la gestione della casella, per esempio
                        l'avvenuta attivazione di SpidMail e la notifica di ricezione nuovi messaggi PEC
                    </>
                }

                <p>Inserisci o verifica i dati richiesti per procedere</p>

                <InputMail
                    value={this.props.detailsPec.email || ''}
                    name="detailsPec_email"
                    handleChange={this.props.handleChange}
                    label={this.props.config.dettaglio_email ?? 'Email'}
                    invalid_message={this.props.errorMessages.detailsPec_email}
                    helpText={this.props.config.dettaglio_email_help}
                    required={true}
                    readOnly={this.props.emailReadOnly}
                />

                {/* Switch per selezione della nazione estera */}
                <React.Fragment>
                    <div className="custom-control custom-switch">
                        <input
                            id="detailsPec_nazioneEstera"
                            name="detailsPec_nazioneEstera"
                            checked={this.state.detailsPec_nazioneEstera}
                            onChange={this.handleCheckboxChange}
                            type="checkbox"
                            role="switch"
                            className='custom-control-input'
                            disabled={this.props.disabled}
                            readOnly={this.state.dataModify}
                        />
                        <label className="custom-control-label col-form-label-sm" htmlFor="detailsPec_nazioneEstera">
                            Risiedo in uno stato estero&nbsp;
                            <a href="#"
                                data-place="bottom"
                                data-class="border-dark"
                                data-type="light"
                                data-multiline="true"
                                data-html={false}
                                data-for="nazione_estera"
                                data-tip={"Se risiedi in una nazione estera, seleziona questa opzione.<br>Potrai procedere all'attivazione della casella<br>inserendo correttamente i dati di residenza."}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                </svg>
                            </a>
                            <ReactTooltip id="nazione_estera" /><br />
                        </label>
                    </div>
                </React.Fragment>
                {/* fine */}

                {/* se nazione estera, mostra InputText ad inserimento libero per mobile number e zip */}
                {this.state.detailsPec_nazioneEstera ?
                    <React.Fragment>
                        <InputPhoneEstero
                            value={this.props.detailsPec.mobileNumber || ''}
                            name="detailsPec_mobileNumber"
                            handleChange={this.props.handleChange}
                            label={this.props.config.dettaglio_cellulare}
                            placeHolder={this.props.config.phone_number_no_prefix}
                            invalid_message={this.props.errorMessages.detailsPec_mobileNumber}
                            maxLength={this.props.config.CELL_MAX_LENGTH}
                            helpText={this.props.config.dettaglio_cellulare_help}
                            required={true}
                            onlyMobile={true}
                            // selectedCountry={this.props.selectedCountry}
                        />
                    </React.Fragment>
                :
                    <React.Fragment>
                        <InputPhone
                            value={this.props.detailsPec.mobileNumber || ''}
                            name={"detailsPec_mobileNumber"}
                            handleChange={this.props.handleChange}
                            label={this.props.config.dettaglio_cellulare}
                            placeHolder={"Inserisci il numero di cellulare"}
                            invalid_message={this.props.errorMessages.detailsPec_mobileNumber}
                            maxLength={this.props.config.CELL_MAX_LENGTH}
                            helpText={this.props.config.dettaglio_cellulare_help}
                            required={true}
                            onlyMobile={true}
                        />
                    </React.Fragment>
                }


                <InputText
                    value={this.props.detailsPec.street || ''}
                    name="detailsPec_street"
                    handleChange={this.props.handleChange}
                    label={this.props.config.dettaglio_indirizzo}
                    invalid_message={this.props.errorMessages.detailsPec_street}
                    maxLength={this.props.config.STREET_MAX_LENGTH}
                    required={true}
                />

                {/* se nazione estera, mostra InputText ad inserimento libero. Altrimenti mostra elenco città */}
                {this.state.detailsPec_nazioneEstera ?
                    <React.Fragment>
                        <InputText
                        name="detailsPec_city"
                        value={this.props.detailsPec.city || ''}
                        handleChange={this.props.handleChange}
                        label={this.props.config.dettaglio_city}
                        invalid_message={this.props.errorMessages.detailsPec_city}
                        maxLength={this.props.config.STREET_MAX_LENGTH}
                        required={true}
                        />

                        <SelectCountry
                            name="detailsPec_country"
                            value={this.props.detailsPec.country || ''}
                            handleChange={this.props.handleChange}
                            label={this.props.config.dettaglio_country || 'Nazione'}
                            invalid_message={this.props.errorMessages.detailsPec_country}
                            required={true}
                        />
                        {/* si imposta la provincia al valore estero EE */}
                        <input type="hidden" name="detailsPec_province" value={'EE'} />

                        <InputText
                            value={this.props.detailsPec.zip || ''}
                            name="detailsPec_zip"
                            handleChange={this.props.handleChange}
                            label={this.props.config.dettaglio_zip}
                            invalid_message={this.props.errorMessages.detailsPec_zip}
                            maxLength={this.props.config.ZIP_MAX_LENGTH_WORLDWIDE}
                            required={true}
                        />
                    </React.Fragment>
                :
                    <React.Fragment>
                        <SelectCitySayt
                            name="detailsPec_city"
                            value={this.props.detailsPec.city || ''}
                            label={this.props.config.dettaglio_city}
                            nameProvince="detailsPec_province"
                            valueProvince={this.props.detailsPec.province || ''}
                            labelProvince={this.props.config.provincia}
                            nameRegion="detailsPec_region"
                            not_selected={this.props.config.selezionare_citta}
                            invalid_message={this.props.errorMessages.detailsPec_city}
                            required={true}
                            hide_province={true}
                            />
                        <InputText
                            value={this.props.detailsPec.zip || ''}
                            name="detailsPec_zip"
                            handleChange={this.props.handleChange}
                            label={this.props.config.dettaglio_zip}
                            invalid_message={this.props.errorMessages.detailsPec_zip}
                            maxLength={this.props.config.ZIP_MAX_LENGTH}
                            required={true}
                        />
                    </React.Fragment>
                }

                <input type="hidden" name="detailsPec_country" value={this.props.detailsPec.country || 'IT'} />
            </React.Fragment>
        );
    }
}
